var bundleLoader = require('./bundle-loader-browser');
var extend = require('raptor-util/extend');
// provide simple object assign in case it is not available
require('./object-assign');

function ContentManager() {
}

ContentManager.prototype = {
    getBundle: function (bundleName, from, callback) {
        if (typeof from === 'function') {
            callback = from;
            from = undefined;
        }

        return bundleLoader.loadBundle(bundleName, callback);
    },

    _getBundles: function (bundleNames, from, callback) {
        if (typeof from === 'function') {
            callback = from;
            from = undefined;
        }
        var len = bundleNames.length;
        if (!len) {
            return callback(null, []);
        }

        var loadedBundles = new Array(len);
        var pending = len;
        var _this = this;
        bundleNames.forEach(function (bundleName, i) {
            _this.getBundle(bundleName, from, function (err, bundle) {
                if (err) {
                    // Fail fast if any bundle failed
                    return callback(err);
                }

                // Record the loaded bundle in the array where it belongs
                loadedBundles[i] = bundle;
                if (--pending === 0) { // If the decremented missing counter is at 0 then we are done
                    callback(null, loadedBundles); // Render the body!
                }
            });
        });
    }
};

extend(ContentManager.prototype, require('./legacy'));

module.exports = ContentManager;
